<template>
  <div class="badge-counter body-xs">
    {{ counter }}
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { BadgeCounterProps } from './types'

const props = defineProps<BadgeCounterProps>()

const counter = computed(() => {
  if (props.value > 99) {
    return '99+'
  } else {
    return props.value
  }
})
</script>

<style lang="scss" scoped>
.badge-counter {
  --size: v-bind(size);

  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: var(--color-base-red-100);
  border-radius: var(--size);
  color: var(--color-base-white);
  font-size: calc(var(--size) / 1.6);
  font-style: normal;
  line-height: 1.6;
  height: var(--size);
  min-width: var(--size);
  padding: 0 calc(var(--size) / 4);
  text-align: center;
  width: fit-content;
}
</style>
